import { toFixed } from 'accounting'
import React, { useContext, useEffect, useMemo } from 'react'
import { IoDocumentAttachSharp } from 'react-icons/io5'
import { ColumnsTable } from 'safe'
import Modal from '../../components/Display/Modal'
import Table from '../../components/Display/Table'
import { ColumnItemWrapper } from '../../components/General/ColumnItemWrapper'
import { ThemeContext } from '../../context/ThemeContext'
import {
  formatPipe,
  getDenomination,
  getItemType,
  transformDate,
} from '../../utils/utils'

const WatchSale : React.FC<IWatchSale> = ({ sale, onSeeDetails, globalRate }) => {
  const { theme } = useContext(ThemeContext)

  let pendingDebt = useMemo(() => {
    let totalPayment = sale?.payments.reduce((a, b) => {
      return a + (+toFixed(+b?.amount, 2) * +toFixed(+b?.rate, 2))
    }, 0)

    let otherWitholding = sale?.otherTaxWithholding.reduce((a, b) => {
      return a + +b?.amountWithheld
    }, 0)

    return formatPipe(toFixed(+sale?.cost - totalPayment - (+sale?.withholding?.amountWithheld || 0) - (+sale?.islrWithholding?.amountWithheld || 0) - (+sale?.aeWithholding?.amountWithheld || 0) - otherWitholding, 2))

  }, [sale])



  let totalWitholding = useMemo(() => {
    let otherWitholding = sale?.otherTaxWithholding.reduce((a, b) => {
      return a + +b?.amountWithheld
    }, 0)

    return formatPipe(toFixed( ((+sale?.withholding?.amountWithheld || 0) + (+sale?.islrWithholding?.amountWithheld || 0) + (+sale?.aeWithholding?.amountWithheld || 0) + otherWitholding) , 2))

  }, [sale])

  const itemsColumns: ColumnsTable[] = [
    {
      title: 'Tipo',
      dataIndex: 'type',
      key: 'type',
      render: (id: number, record: any) => (
        <ColumnItemWrapper subElement="paragraph">
          {getItemType(record?.type)?.value || 'Servicio'}
        </ColumnItemWrapper>
      ),
    },
    {
      title: 'Nombre',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Cantidad',
      dataIndex: 'amount',
      key: 'amount',
      // render: (id: number, record: any) => (
      //   <ColumnItemWrapper
      //     subElement="paragraph"
      //     subElementStyle={`${record?.barcode ? '' : 'text-gray-600'}`}
      //   >
      //     {record?.barcode ? record?.barcode : 'N/A'}
      //   </ColumnItemWrapper>
      // ),
    },
    // {
    //   title: 'Excento',
    //   dataIndex: 'exempt',
    //   key: 'exempt',
    //   render: (id: number, record: any) => (
    //     <ColumnItemWrapper>
    //       <p>{record?.exempt ? 'Sí' : 'No'}</p>
    //     </ColumnItemWrapper>
    //   ),
    // },
    {
      title: 'Precio',
      dataIndex: 'price',
      key: 'price',
      render: (id: number, record: any) => (
        <ColumnItemWrapper>
          {`${getDenomination(record?.currency?.id)} ${formatPipe(
            record?.price
          )}`}
        </ColumnItemWrapper>
      ),
      // render: (id: number, record: any) => (
      //   <ColumnItemWrapper>
      //     <p
      //       className={`${
      //         !(record?.cost.length > 0) ? 'text-warning' : 'text-success'
      //       }`}
      //     >
      //       {record?.cost.length > 0 ? (
      //         'Bs ' + record?.cost[0]?.amount
      //       ) : (
      //         <span>
      //           Sin Precio <FiAlertTriangle className="text-warning inline" />
      //         </span>
      //       )}
      //     </p>
      //   </ColumnItemWrapper>
      // ),
    },
  ]

  const paymentsColumns: ColumnsTable[] = [
    {
      title: 'Cuenta',
      dataIndex: 'account.code',
      key: 'account.code',
    },
    {
      title: 'Monto',
      dataIndex: 'amount',
      key: 'amount',
      render: (id: number, record: any) => (
        <ColumnItemWrapper>
          {`${getDenomination(record?.currency?.id)} ${formatPipe(
            record?.amount
          )}`}
        </ColumnItemWrapper>
      ),
    },
    {
      title: 'Fecha',
      dataIndex: 'date',
      key: 'date',
      render: (id: number, record: any) => (
        <ColumnItemWrapper subElement="paragraph">
          {transformDate(record?.date)}
        </ColumnItemWrapper>
      ),
    },
    {
      title: 'Referencia',
      dataIndex: 'reference',
      key: 'reference',
    },
  ]

  const onGetRate = (idCurrency: string | undefined): string => {
    return globalRate?.find((rate) => rate.id === idCurrency)?.rate || '1'
  }

  let subTotal = useMemo(() => {

    const checkGlobalRate = Object.keys(globalRate).length > 0
    if (sale?.items && checkGlobalRate) {
      return sale?.items?.reduce((a, b) => {
        return a + +b?.amount * +onGetRate(b?.currency?.id) * b?.price
      }, 0)
    }
    return 0
  }, [sale, globalRate])

  return (
    <>
      <h2 className="ml-5 mb-5 text-primary dark:text-white font-bold text-3xl">
        Ver venta
      </h2>
      <div
        className="grid grid-cols-12 auto-rows-fr gap-4"
        style={{ height: '100%' }}
      >
        <div
          className="col-span-6"
          style={{ height: '100%', overflow: 'auto' }}
        >
          <Table
            columns={itemsColumns}
            data={
              sale?.items && sale?.services
                ? [...sale?.items, ...sale?.services]
                : sale?.items
                ? sale?.items
                : sale?.services
            }
            showPagination={false}
          />
        </div>

        <div className="col-span-6">
          <div
            className="grid grid-cols-12 grid-rows-12 auto-rows-fr gap-4"
            style={{ height: '100%' }}
          >
            <div
              className="dark:bg-black bg-primaryGray-1300 col-span-6 row-start-1	row-end-7 p-3 overflow-auto"
              style={{
                borderRadius: 6,
                boxShadow: theme === 'light' ? '0px 3px 4px 3px #cccccc40' : '',
              }}
            >
              <h2
                className="text-xs font-medium mb-1"
                style={{ color: '#006AEA' }}
              >
                Resumen General
              </h2>
              <h2 className="text-xs font-medium mb-1">
                Descuento: Bs {formatPipe(sale?.discount)}
              </h2>
              <h2 className="text-xs font-medium mb-1">
                Exento: Bs {formatPipe(sale?.exempt)}
              </h2>
             
              <h2 className="text-xs font-medium mb-1">
                IGFT: Bs {formatPipe(sale?.igtf)}
              </h2>
              <h2 className="text-xs font-medium mb-1">
              Base imponible I.V.A general 16%: Bs {formatPipe(sale?.generalTaxableBase || "0.00")}
              </h2>
              <h2 className="text-xs font-medium mb-1">
              I.V.A General 16%: Bs {formatPipe(sale?.generalIVA || "0.00")}
              </h2>

              { sale?.sumptuaryIVA !== '0.00' && (
              <h2 className="text-xs font-medium mb-1">
                Base imponible I.V.A suntuario 15%: Bs {formatPipe(sale?.sumptuaryTaxableBase || "0.00")}
              </h2>
              ) }

              { sale?.sumptuaryIVA !== '0.00' && (
              <h2 className="text-xs font-medium mb-1">
                I.V.A Suntuario 15%: Bs {formatPipe(sale?.sumptuaryIVA || "0.00")}
              </h2>
              ) }

              { sale?.reducedIVA !== '0.00' && (
              <h2 className="text-xs font-medium mb-1">
                Base imponible I.V.A reducido 8%: Bs {formatPipe(sale?.reducedTaxableBase)}
              </h2>
              ) }
              
              { sale?.reducedIVA !== '0.00' && (
              <h2 className="text-xs font-medium mb-1">
                I.V.A Reducido 8%: Bs {formatPipe(sale?.reducedIVA)}
              </h2>
              ) }
              
              

              <h2 className="text-xs font-medium mb-1">
                Monto total: Bs {formatPipe(sale?.cost)}
              </h2>
              <h2 className="text-xs font-medium mb-1">
                Monto total en REF.: $ {formatPipe(sale?.usdCost)}
              </h2>
              <h2 className="text-xs font-medium mb-1">
                Cambio: {pendingDebt}
              </h2>
              {/* <h2 className="text-xs font-medium mb-1">
                Almacén: {'Piso de venta'}
              </h2> */}
            </div>
            <div
              className="dark:bg-black bg-primaryGray-1300 col-span-6 row-start-1 row-end-4 p-3"
              style={{
                borderRadius: 6,
                boxShadow: theme === 'light' ? '0px 3px 4px 3px #cccccc40' : '',
              }}
            >
              <div className="flex flex-row mb-1">
                <IoDocumentAttachSharp className="text-primary mb-2 mr-3" />
                <h2
                  className="text-xs font-medium"
                  style={{ color: '#006AEA' }}
                >
                  Datos del cliente
                </h2>
              </div>

              <h2 className="text-xs font-medium mb-1">
                Razón social: {sale?.client?.name}
              </h2>
              {/* <h2 className="text-xs font-medium mb-1">
                    Nombre comercial: Las 3 Marias
                  </h2> */}
              <h2 className="text-xs font-medium mb-1">
                Documento: {sale?.client?.documentType}-{sale?.client?.document}
              </h2>
              {/* <h2 className="text-xs font-medium mb-1">
                    Dirección Fiscal: Av Bella vista calle 80{' '}
                  </h2> */}
            </div>
            <div
              className="dark:bg-black bg-primary-1500 col-span-6 row-span-3 p-3"
              style={{
                borderRadius: 6,
                boxShadow: theme === 'light' ? '0px 3px 4px 3px #cccccc40' : '',
              }}
            >
              <h2
                className="text-xs font-medium mb-1"
                style={{ color: '#006AEA' }}
              >
                Devoluciones
              </h2>

              {sale?.creditNote?.code ? (
                <div>
                  <h2 className="text-xs font-medium mb-1">
                    {/* Almacén: {sale?.warehouse?.name} */}
                    Fecha:{' '}
                    {sale?.creditNote?.date
                      ? transformDate(sale?.creditNote?.date)
                      : 'N/A'}
                  </h2>

                  <h2 className="text-xs font-medium mb-1">
                    Total: {formatPipe(sale?.cost)}
                  </h2>

                  <h2 className="text-xs font-medium mb-1">
                    Nro. Nota: {sale?.creditNote?.code}
                  </h2>
                </div>
              ) : (
                <h2 className="text-xs font-medium mb-1">
                  No hay ninguna devolución
                </h2>
              )}
            </div>
            <div
              className="dark:bg-black bg-primary-1500 col-span-6 row-span-4 p-3"
              style={{
                borderRadius: 6,
                boxShadow: theme === 'light' ? '0px 3px 4px 3px #cccccc40' : '',
              }}
            >
              <h2
                className="text-xs font-medium mb-1"
                style={{ color: '#006AEA' }}
              >
                Factura
              </h2>

              <h2 className="text-xs font-medium mb-1">
                Fecha: {sale?.date ? transformDate(sale?.date) : 'N/A'}
              </h2>

              {/* <h2 className="text-xs font-medium mb-1">
                    Nmo. de control: {sale?.invoice?.code || 'N/A'}
                  </h2> */}

              <h2 className="text-xs font-medium mb-1">
                Nro. de Factura: {sale?.invoice?.code || 'N/A'}
              </h2>

              <h2 className="text-xs font-medium mb-1">
                Nro. de Documento: {sale?.invoice?.control || 'N/A'}
              </h2>

              <h2 className="text-xs font-medium mb-1">
                Estado: {sale?.cancelled ? 'Anulada' : 'Pagado'}
              </h2>
            </div>

            <div
              className="dark:bg-black bg-primaryGray-1300 col-span-6 row-span-4 p-3 col-start-7"
              style={{
                borderRadius: 6,
                boxShadow: theme === 'light' ? '0px 3px 4px 3px #cccccc40' : '',
              }}
            >
              <h2
                className="text-xs font-medium mb-1"
                style={{ color: '#006AEA' }}
              >
                Retenciones
              </h2>

              <h2 className="text-xs font-medium mb-1">
                Total Retenido: Bs {totalWitholding}
              </h2>

              <h2
                className="text-xs font-medium mb-1 cursor-pointer"
                style={{ color: '#006AEA' }}
                onClick={() => onSeeDetails && onSeeDetails()}
              >
                Ver detalles
              </h2>
            </div>

            <div
              className="dark:bg-black bg-primaryGray-1300 col-span-12 row-span-5 p-3"
              style={{
                height: '100%',
                overflow: 'auto',
                borderRadius: 6,
                boxShadow: theme === 'light' ? '0px 3px 4px 3px #cccccc40' : '',
              }}
            >
              <h2
                className="text-xs font-medium mb-3"
                style={{ color: '#006AEA' }}
              >
                Pagos realizados
              </h2>
              <Table
                columns={paymentsColumns}
                data={sale?.payments}
                showPagination={false}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

interface IWatchSale {
  sale: any
  onSeeDetails?: () => void
  globalRate: any
}

export default WatchSale
